// import React from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { set_value_toolbox, toolbox_handle_back, toolbox_handle_new_object, toolbox_handle_stop } from '../../App/actions/toolboxActions'
import { Draggable } from '../reuseable'
import useLanguage from '../common_hooks/useLanguage'
// import uuid from '../../App/validation/uuid'

function TOOLBOX_COMPANION() {
  const toolbox = useSelector((state) => (state.toolbox))
  const { is_mobile } = useSelector((state) => (state.properties))
  const { statistic_mode } = useSelector((state) => (state.layer))
  const {
    // uuid_name,
    // routing_active_uuid,
    // features_routing_obj,
    mode_toolbox,
    name_toolbox,
    description,
    mode_draw,
    last_saved_feature_uuid,
    modal_cancel_confirmation,
    source_tab,
    is_need_toolbox_companion,
    // visible_routing
  } = toolbox || {};
  // const selected_row_toolbox_ids = toolbox[uuid_name];

  const features = toolbox[mode_toolbox];

  const dispatch = useDispatch();
  const {dict, language} = useLanguage();
  const handle_stop_toolbox = () => {
    dispatch(toolbox_handle_stop());
  }

  const handle_new_object = () => {
    dispatch(toolbox_handle_new_object());
  }

  const set_modal_cancel_confirmation = (value) => {
    let new_value = !modal_cancel_confirmation?.is_open
    if (value === false || value === true) {
      new_value = value;
    }

    let last_saved_feature_uuid_index;
    if (last_saved_feature_uuid === "") last_saved_feature_uuid_index = Infinity;
    else if (last_saved_feature_uuid === "start") last_saved_feature_uuid_index = -1;
    else {
      // partial save
      last_saved_feature_uuid_index = features.findIndex(
        f => f.properties.uuid === last_saved_feature_uuid
      );
    }

    if (
      last_saved_feature_uuid_index < features.length && features.length > 0
    ) {
      dispatch(set_value_toolbox({
        key: "modal_cancel_confirmation",
        value: {
          is_open: new_value,
          is_back_active: false
        }
      }));
    } else {
      dispatch(toolbox_handle_back());
    }
  }

  const handle_new_routing = () => {
    dispatch(set_value_toolbox({
      key: "routing_active_uuid",
      value: "",
    }));
  }

  const is_drawing = [
    "draw_polygon",
    "draw_line_string",
    "draw_point"
  ].includes(mode_draw) ? true : false;

  return (
    <>
      {is_need_toolbox_companion &&
        statistic_mode === "toolbox" &&
        source_tab === 0 &&
        <Draggable
          style={{
            background: "white",
            width: "230px",
            zIndex: 0,

            backgroundColor: "white",
            borderRadius: "20px",
            color: "black",
            gap: "15px",
          }}
          initialPosition={{
            x: is_mobile ? 20 : window.innerWidth - 600,
            y: is_mobile ? 65 : 80,
          }}
        >
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              gap: "15px",
              padding: "5px"
            }}
          >
            {name_toolbox &&
              <section
                style={{
                  fontFamily: 'Figtree',
                  fontWeight: 700,
                  fontSize: "16px",
                  lineHeight: "19px",
                  color: "#000000",
                }}
              >
                {name_toolbox}
              </section>}

            {description && <section
              style={{
                fontSize: "12px"
              }}
            >
              {description}
            </section>}

            <hr style={{
              borderBottom: "1px solid #ABABAB",
              opacity: "80%",
              borderTop: "none"
            }} />

            <section
              style={{
                display: "flex",
                flexDirection: "column",
                gap: "10px"
              }}
            >
              {mode_toolbox === "features_routing" ?
                <button
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    padding: "7px 13px",
                    gap: "10px",
                    background: "white",
                    color: "black",
                    border: `1px solid black`,
                    borderRadius: "20px",
                    width: "100%",
                    fontSize: "12px"
                  }}
                  onClick={() => { handle_new_routing() }}
                >
                  {dict["+ New Routing"][language]}
                </button>
                : <button
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    padding: "7px 13px",
                    gap: "10px",
                    background: is_drawing ? "black" : "white",
                    color: is_drawing ? "white" : "black",
                    border: `1px solid black`,
                    borderRadius: "20px",
                    width: "100%",
                    fontSize: "12px"
                  }}
                  onClick={() => {
                    if (is_drawing) handle_stop_toolbox();
                    else handle_new_object();
                  }}
                >
                  {is_drawing ? dict["Stop"][language] : dict["+ New Object"][language]}
                </button>}


              {is_drawing && mode_toolbox !== "features_routing" && <button
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  padding: "7px 13px",
                  gap: "10px",
                  background: "white",
                  border: "1px solid #BD0000",
                  color: "#BD0000",
                  borderRadius: "20px",
                  width: "100%",
                  fontSize: "12px"
                }}
                onClick={() => set_modal_cancel_confirmation(true)}
              >
                {dict["Cancel"][language]}
              </button>}
            </section>
          </div >
        </Draggable >}
    </>
  )
}

export default TOOLBOX_COMPANION